// extracted by mini-css-extract-plugin
export default {"oldStatementDialog":"On3PZ","button":"TcomY"};